import React, { useState, useEffect } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Tooltip,
} from "reactstrap"
import { fetchData, fetchNodeData } from "utils/common-fetchData"
import Loader from "pages/Separate/Loader"
import secureLocalStorage from "react-secure-storage"
import Select from "react-select"
// import { FaEye, FaRegCalendarAlt } from "react-icons/fa"
import NewPagination from "components/Common/Newpagination"
import TimesheetTable from "./TimesheetTable"
import moment from "moment"
import * as XLSX from "xlsx"
import { data } from "autoprefixer"
import configure from "configure"
import axios from "axios"
import "../../../assets/css/dashboard.css"
import viewImg from "../../../assets/images/Inventory/viewImg.jpg"

const AdvancedTimesheetReport = () => {
  const [selectedFilter, setSelectedFilter] = useState("currentYear")
  const [selectedMonth, setSelectedMonth] = useState("")
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [selectedStaff, setSelectedStaff] = useState("")
  const [isLoading, setLoading] = useState(false)
  const [staf, setStaf] = useState([])
  const [cardData, setCardData] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedCard, setSelectedCard] = useState(null)

  // Separate tooltip states
  const [leaveTooltipOpen, setLeaveTooltipOpen] = useState(false)
  const [pendingTooltipOpen, setPendingTooltipOpen] = useState(false)
  const [expTooltipOpen, setExpTooltipOpen] = useState(false)
  const [actTooltipOpen, setActTooltipOpen] = useState(false)
  const [avgTooltipOpen, setAvgTooltipOpen] = useState(false)
  const [dayTooltipOpen, setDayTooltipOpen] = useState(false)
  const [showReport, setShowReport] = useState(false)
  const [currentPage, setCurrentPage] = useState(0)
  const [cardsPerPage, setCardsPerPage] = useState(4)
  const [pageSize, setPageSize] = useState(4)

  const [pendingDayClose, setPendingDayClose] = useState(0)
  const [pendingDatesList, setPendingDatesList] = useState([])
  const [minHrs, setMinHrs] = useState(null)
  const [leaves, setLeaves] = useState([])
  const [dailyTimes, setDailyTimes] = useState({})
  const [totalHours, setTotalHours] = useState(null)
  const [averagePerDay, setAveragePerDay] = useState(null)
  const token = secureLocalStorage.getItem("auth_token")

  // const handleTotalTimeChange = (date, time) => {
  //   setDailyTimes(prev => ({
  //     ...prev,
  //     [date]: time
  //   }))
  // }

  const calculateAllDatesTotal = async (staffId, cards) => {
    try {
      let grandTotalSeconds = 0
      const dailyTotals = {} // store Total1 per date

      for (const card of cards) {
        const workLoadUrl = `${configure.nodeApi}/TimeSheetReport/${card.date}/${card.date}/${staffId}`
        const pendingTaskUrl = `${configure.nodeApi}/pendingTasks/${staffId}/${card.date}/${card.date}`

        const [res, res2] = await Promise.all([
          axios.get(workLoadUrl),
          axios.get(pendingTaskUrl),
        ])

        let daySeconds = 0

        // ---------- TimeSheetReport ----------
        if (res?.data?.success) {
          const fetchedData = res.data.data.allData || []

          fetchedData.forEach(item => {
            if (item.total_actual_time != null) {
              if (typeof item.total_actual_time === "number") {
                // total_actual_time in minutes
                daySeconds += item.total_actual_time * 60
              } else if (typeof item.total_actual_time === "string") {
                // total_actual_time in "HH:MM" format
                const [h = 0, m = 0] = item.total_actual_time
                  .split(":")
                  .map(Number)
                daySeconds += h * 3600 + m * 60
              }
            }
          })
        }

        // ---------- Pending Tasks ----------
        if (res2?.data?.success) {
          res2.data.data.forEach(r => {
            const [h = 0, m = 0, s = 0] = r.totaltime.split(":").map(Number)
            daySeconds += h * 3600 + m * 60 + s
          })
        }

        // Store per-date Total1 in HH:MM:SS format
        const formattedDay = new Date(daySeconds * 1000)
          .toISOString()
          .substr(11, 8)
        dailyTotals[card.date] = formattedDay

        // Add to grand total
        grandTotalSeconds += daySeconds
      }

      const grandTotalFormatted = new Date(grandTotalSeconds * 1000)
        .toISOString()
        .substr(11, 8)

      // Update state
      setDailyTimes({ ...dailyTotals, grandTotal: grandTotalFormatted })
      setTotalHours(grandTotalFormatted)

      // Average per day
      const totalDays = cards.length
      const averageSeconds =
        totalDays > 0 ? Math.floor(grandTotalSeconds / totalDays) : 0
      const averageFormatted = new Date(averageSeconds * 1000)
        .toISOString()
        .substr(11, 8)

      // Update state
      setDailyTimes({
        ...dailyTotals,
        grandTotal: grandTotalFormatted,
        average: averageFormatted,
      })

      console.log("Daily Totals per date:", dailyTotals)
      console.log("Grand Total of all dates:", grandTotalFormatted)
      console.log("Average per day:", averageFormatted)
      setAveragePerDay(averageFormatted)
    } catch (err) {
      console.error(err)
    }
  }

  const totalActualHours = Object.values(dailyTimes).reduce((total, time) => {
    if (!time) return total

    const [h = 0, m = 0, s = 0] = time.split(":").map(Number)
    const seconds = h * 3600 + m * 60 + s

    return total + seconds
  }, 0)

  const formattedTotalActualHours = new Date(totalActualHours * 1000)
    .toISOString()
    .substr(11, 8)

  useEffect(() => {
    fetchStaffOptions()
  }, [])

  const fetchStaffOptions = async () => {
    const res = await fetchData(setLoading, "staff", token)
    setStaf(res?.data)
  }

  const toggleModal = card => {
    setSelectedCard(card)
    setModalOpen(!modalOpen)
  }

  const toggleLeaveTooltip = () => setLeaveTooltipOpen(prev => !prev)
  const togglePendingTooltip = () => setPendingTooltipOpen(prev => !prev)
  const toggleExpTooltip = () => setExpTooltipOpen(!expTooltipOpen)
  const toggleActTooltip = () => setActTooltipOpen(!actTooltipOpen)
  const toggleAvgTooltip = () => setAvgTooltipOpen(!avgTooltipOpen)
  const toggleDayTooltip = () => setDayTooltipOpen(!dayTooltipOpen)
  useEffect(() => {
    document.title = "Advanced Timesheet Report | Zithas CRM"
  }, [])

  useEffect(() => {
    const updateCardsPerPage = () => {
      if (window.innerWidth >= 1200) setCardsPerPage(6)
      else if (window.innerWidth >= 768) setCardsPerPage(4)
      else setCardsPerPage(2)
    }

    updateCardsPerPage()
    window.addEventListener("resize", updateCardsPerPage)
    return () => window.removeEventListener("resize", updateCardsPerPage)
  }, [])

  const effectivePageSize = pageSize || cardsPerPage
  const pageCount = Math.ceil(cardData.length / effectivePageSize)
  const currentCards = cardData.slice(
    currentPage * effectivePageSize,
    currentPage * effectivePageSize + effectivePageSize
  )

  const gotoPage = pageIndex => {
    setCurrentPage(pageIndex)
  }

  // ------------------- FETCH CLOSED DATA USING fetchNodeData -------------------
  // Updated to accept staffId, startDate, endDate directly to avoid async state issue
  const handleClosedData = async (staffId, fromdate, todate) => {
    if (!staffId || !fromdate || !todate) {
      alert("Please select Staff, Start Date, and End Date")
      return
    }

    try {
      setLoading(true)

      const apiUrl = `alltodaysTasks/get/${staffId}/${fromdate}/${todate}`
      const apiUrl2 = `leavesData/${staffId}/${staffId}`
      const res = await fetchNodeData(setLoading, apiUrl, token)
      const res2 = await fetchData(setLoading, apiUrl2, token)

      if (res2?.success) {
        const leaveData = res2.data || []

        const from = new Date(fromdate)
        const to = new Date(todate)

        const filteredLeaves = leaveData.filter(l => {
          const start = new Date(l.start_date)
          const end = new Date(l.end_date)

          return start <= to && end >= from
        })

        setLeaves(filteredLeaves)
      }
      setMinHrs(res?.min_hrs)
      console.log("Minnimum Houres", res?.min_hrs)

      if (res?.success) {
        const fetchedData = res.data || []

        // Map only dates with data
        const cards = fetchedData.map(item => ({
          id: item.id,
          date: item.date,
          dayClosed: item.dayClosed ?? true,
          totalHr: item.totalHr || "0:00",
        }))

        // -------------- Pending Day Close Calculation --------------
        const getAllDatesInRange = (start, end) => {
          const dateArray = []
          let currentDate = new Date(start)
          const lastDate = new Date(end)

          while (currentDate <= lastDate) {
            dateArray.push(new Date(currentDate))
            currentDate.setDate(currentDate.getDate() + 1)
          }
          return dateArray
        }

        // Corrected isHoliday to ignore Sundays and 1st/3rd Saturdays
        const isHoliday = date => {
          const day = date.getDay() // 0=Sunday, 6=Saturday
          if (day === 0) return true // Sunday

          if (day === 6) {
            // Saturday
            const dateOfMonth = date.getDate()
            const weekOfMonth = Math.floor((dateOfMonth - 1) / 7) + 1
            if (weekOfMonth === 1 || weekOfMonth === 3) return true // 1st or 3rd Saturday
          }

          return false
        }

        const allDates = getAllDatesInRange(fromdate, todate)
        const fetchedDatesSet = new Set(
          cards.map(c => new Date(c.date).toISOString().split("T")[0])
        )

        const pendingDates = allDates.filter(d => {
          const dStr = d.toISOString().split("T")[0]
          return !isHoliday(d) && !fetchedDatesSet.has(dStr)
        })

        setPendingDayClose(pendingDates.length)
        setPendingDatesList(pendingDates.map(d => formatDate(d.toISOString())))
        // ------------------------------------------------------------

        setCardData(cards)
        console.log("card data", cards)
        calculateAllDatesTotal(staffId, cards)
        console.log("Cardsss", cards)
        setCurrentPage(0)
        setShowReport(true)
        if (cards.length > 0) {
          setSelectedCard(cards[0])
        }
      }
    } catch (error) {
      console.error("Error fetching closed data:", error)
    } finally {
      setLoading(false)
    }
  }

  const handleExportAllDates = async () => {
    if (!selectedStaff || !startDate || !endDate) {
      alert("Please select Staff, Start Date, and End Date")
      return
    }

    const timeToSeconds = time => {
      if (!time) return 0

      if (typeof time === "number") return time * 60

      const parts = time.split(":").map(Number)

      if (parts.length === 2) return parts[0] * 3600 + parts[1] * 60
      if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2]

      return 0
    }

    const formatDate = item => {
      const date =
        item.date ||
        item.updated_at || // activity uses this
        item.updatedAt || // support_ticket uses this
        item.createdAt ||
        item.start_time

      return date ? moment(date).format("DD-MM-YYYY") : ""
    }

    const formatTime = time => {
      return time ? moment(time).format("HH:mm") : ""
    }

    try {
      setLoading(true)

      const staffId = selectedStaff

      const workLoadUrl = `${configure.nodeApi}/TimeSheetReport/${startDate}/${endDate}/${staffId}`
      const pendingTaskUrl = `${configure.nodeApi}/pendingTasks/${staffId}/${startDate}/${endDate}`

      const [res, res2] = await Promise.all([
        axios.get(workLoadUrl),
        axios.get(pendingTaskUrl),
      ])

      const exportData = []

      /* ---------------- Timesheet Tasks ---------------- */

      if (res?.data?.success) {
        const allData = res.data.data.allData || []
        const qaTasks = allData.filter(item => item.type === "qa_task")
        const activities = allData.filter(item => item.type === "activity")

        console.log("QA Tasks:", qaTasks)
        console.log("Activities:", activities)

        allData.forEach(item => {
          let startTime = null
          let endTime = null

          // For tasks that actually store start/end
          if (item.start_time || item.end_time) {
            startTime = item.start_time
            endTime = item.end_time
          }

          // For project tasks with timelogs
          else if (item.timelogs && item.timelogs.length) {
            startTime = item.timelogs[0].start_time
            endTime = item.timelogs[item.timelogs.length - 1].end_time
          }

          exportData.push({
            "Sr No.": exportData.length + 1,
            Type: item.type,
            "Activity Name": item.task_title || item.title,
            Date: formatDate(item),
            "Start Time": startTime ? formatTime(startTime) : "--",
            "End Time": endTime ? formatTime(endTime) : "--",
            "Total Time": item.total_actual_time || item.time || "00:00:00",
            Approval: "--",
          })
        })
      }

      /* ---------------- Manual Tasks ---------------- */

      /* ---------------- Manual Tasks ---------------- */
      /* ---------------- Manual Tasks ---------------- */
      if (res2?.data?.success) {
        const rowsData = res2.data.data
        console.log("Manual Tasks:", rowsData)

        const allowedDates = new Set(
          cardData.map(c => moment(c.date).format("DD-MM-YYYY"))
        )

        rowsData.forEach(item => {
          const dateStr = item.date
            ? moment(item.date).format("DD-MM-YYYY")
            : ""

          if (allowedDates.has(dateStr)) {
            // Determine Type
            let typeLabel = "Manual"
            if (item.project_type === 0) typeLabel = "Manual - Development"
            else if (item.project_type === 1)
              typeLabel = "Manual - Digital Marketing"
            else if (item.project_type === 2) typeLabel = "Manual - Other"

            // Activity Name with project name prefix
            const projectName = item.project?.project_name || "Unknown Project"
            const activityName = `${projectName} - ${item.title}`

            exportData.push({
              "Sr No.": exportData.length + 1,
              Type: typeLabel,
              "Activity Name": activityName,
              Date: dateStr,
              "Start Time": item.start_time || "--",
              "End Time": item.end_time || "--",
              "Total Time": item.totaltime || "00:00:00",
              Approval:
                item.approved === 1
                  ? "Approved"
                  : item.approved === 0
                  ? "Pending"
                  : "Disapproved",
            })
          }
        })
      }

      /* ---------------- Total Time ---------------- */

      // Convert totalHours string "HH:mm:ss" to seconds
      const totalHoursSeconds = totalHours
        ? totalHours
            .split(":")
            .map(Number)
            .reduce((acc, curr, idx) => {
              if (idx === 0) return acc + curr * 3600 // hours
              if (idx === 1) return acc + curr * 60 // minutes
              return acc + curr // seconds
            }, 0)
        : 0

      // Calculate total seconds for pending tasks (unverified)
      const unverifiedSeconds = exportData
        .filter(item => item.Approval === "Pending")
        .reduce((acc, curr) => acc + timeToSeconds(curr["Total Time"]), 0)

      // Verified time = totalHoursSeconds - unverifiedSeconds
      const verifiedSeconds = totalHoursSeconds - unverifiedSeconds

      // Format HH:mm:ss
      const formatHMS = seconds => {
        const hh = String(Math.floor(seconds / 3600)).padStart(2, "0")
        const mm = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0")
        const ss = String(seconds % 60).padStart(2, "0")
        return `${hh}:${mm}:${ss}`
      }

      // Push row in Excel
      exportData.push({
        "Total Time Taken": totalHours || "00:00:00",
        "Unverified Time": formatHMS(unverifiedSeconds),
        "Verified Time": formatHMS(verifiedSeconds),
      })

      /* ---------------- Excel Export ---------------- */

      const workbook = XLSX.utils.book_new()
      const worksheet = XLSX.utils.json_to_sheet(exportData)

      XLSX.utils.book_append_sheet(workbook, worksheet, "Timesheet")

      XLSX.writeFile(
        workbook,
        `Timesheet_Report_${startDate}_to_${endDate}.xlsx`
      )
    } catch (err) {
      console.error("Error exporting timesheet:", err)
    } finally {
      setLoading(false)
    }
  }

  // Format date for card display
  const formatDate = dateStr => {
    if (!dateStr) return ""
    const date = new Date(dateStr)
    const options = { day: "2-digit", month: "long", year: "numeric" }
    return date.toLocaleDateString("en-US", options) // e.g., 02 March 2026
  }

  const totalLeaveDays = leaves.reduce(
    (sum, l) => sum + (Number(l.leave_days) || 0),
    0
  )
  const totalExpectedHours =
    minHrs && cardData.length ? minHrs * cardData.length : 0

  return (
    <React.Fragment>
      {isLoading && <Loader />}

      <div className="page-content mb-4 ">
        <Container fluid>
          <Breadcrumbs
            title="Dashboard"
            breadcrumbItem="Advanced Timesheet Report"
          />

          <Row className="mb-3 align-items-center">
            {/* LEFT SIDE FILTERS */}
            <Col className="d-flex gap-3 flex-wrap">
              {/* Start Date */}
              <div className="d-flex flex-column" style={{ width: "180px" }}>
                <label
                  className="form-label mb-1 ms-2"
                  style={{
                    fontSize: "0.8125rem",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  Start Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={e => setStartDate(e.target.value)}
                />
              </div>

              {/* End Date */}
              <div className="d-flex flex-column" style={{ width: "180px" }}>
                <label
                  className="form-label mb-1 ms-2"
                  style={{
                    fontSize: "0.8125rem",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  End Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={e => setEndDate(e.target.value)}
                />
              </div>

              {/* Staff */}
              <div className="d-flex flex-column" style={{ width: "200px" }}>
                <label
                  className="form-label mb-1 ms-2"
                  style={{
                    fontSize: "0.8125rem",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  Staff{" "}
                </label>
                <Select
                  placeholder="Select Staff"
                  className="basic-select"
                  classNamePrefix="select"
                  options={staf?.map(s => ({ value: s.id, label: s.name }))}
                  value={staf
                    ?.map(s => ({ value: s.id, label: s.name }))
                    .find(option => option.value === selectedStaff)}
                  onChange={option => {
                    const staffId = option?.value
                    setSelectedStaff(staffId)
                    if (staffId && startDate && endDate) {
                      handleClosedData(staffId, startDate, endDate)
                    }
                  }}
                  isSearchable
                />
              </div>
              {showReport && (
                <div style={{ width: "100%" }}>
                  <button
                    className="btn btn-success mt-2"
                    onClick={handleExportAllDates}
                  >
                    <i className="fas fa-download me-2"></i> Export Timesheet
                  </button>
                </div>
              )}
            </Col>

            {/* RIGHT SIDE PAGE SIZE AND SUMMARY */}
            <Col className="ms-auto d-flex align-items-center gap-2 flex-wrap justify-content-end">
              {showReport && (
                <div className="d-flex align-items-center gap-2 flex-wrap summary-container">
                  <Button
                    id="leaveBtn"
                    className="summary-box summary-leave"
                    outline
                  >
                    <span>Total Leave</span>
                    <span className="summary-value">{totalLeaveDays}</span>
                  </Button>

                  <Tooltip
                    placement="bottom"
                    isOpen={leaveTooltipOpen}
                    target="leaveBtn"
                    toggle={toggleLeaveTooltip}
                    style={{ whiteSpace: "pre-line", maxWidth: "280px" }}
                  >
                    {leaves.length > 0
                      ? leaves
                          .map(
                            l =>
                              `${formatDate(l.start_date)} → ${formatDate(
                                l.end_date
                              )} (${l.leave_days} day)`
                          )
                          .join("\n")
                      : "No leaves"}
                  </Tooltip>

                  <Button id="expHrsBtn" className="summary-box" outline>
                    <span>Exp Hrs</span>
                    <span className="summary-value">{totalExpectedHours}</span>
                  </Button>

                  <Tooltip
                    placement="bottom"
                    isOpen={expTooltipOpen}
                    target="expHrsBtn"
                    toggle={toggleExpTooltip}
                  >
                    Total Expected Hours
                  </Tooltip>

                  <Button id="actHrsBtn" className="summary-box" outline>
                    <span>Act Hrs</span>
                    <span className="summary-value">
                      {totalHours || "00:00:00"}
                    </span>
                  </Button>

                  <Tooltip
                    placement="bottom"
                    isOpen={actTooltipOpen}
                    target="actHrsBtn"
                    toggle={toggleActTooltip}
                  >
                    Total Actual Hours
                  </Tooltip>

                  <Button id="avgBtn" className="summary-box" outline>
                    <span>Avg/Day</span>
                    <span className="summary-value">
                      {averagePerDay || "00:00:00"}
                    </span>
                  </Button>

                  <Tooltip
                    placement="bottom"
                    isOpen={avgTooltipOpen}
                    target="avgBtn"
                    toggle={toggleAvgTooltip}
                  >
                    Average Per Day
                  </Tooltip>

                  <Button id="perDayBtn" className="summary-box" outline>
                    <span>Day Hrs</span>
                    <span className="summary-value">{minHrs}</span>
                  </Button>

                  <Tooltip
                    placement="bottom"
                    isOpen={dayTooltipOpen}
                    target="perDayBtn"
                    toggle={toggleDayTooltip}
                  >
                    Per Day Hours
                  </Tooltip>

                  <Button
                    id="pendingBtn"
                    className="summary-box summary-pending"
                    outline
                  >
                    <span>Pending Closed</span>
                    <span className="summary-value">{pendingDayClose}</span>
                  </Button>

                  <Tooltip
                    placement="bottom"
                    isOpen={pendingTooltipOpen}
                    target="pendingBtn"
                    toggle={togglePendingTooltip}
                    style={{ whiteSpace: "pre-line", maxWidth: "200px" }}
                  >
                    {pendingDatesList.length > 0
                      ? pendingDatesList.join("\n")
                      : "No pending days"}
                  </Tooltip>
                </div>
              )}
            </Col>
          </Row>

          <div className="card p-3 pe-0">
            {showReport ? (
              <div className="row mx-0 mt-2">
                {/* LEFT SIDE DATES */}
                <div
                  className="col-md-2 py-3"
                  style={{
                    overflow: "auto",
                    scrollbarWidth: "thin",
                    backgroundColor: "#f0e8f4",
                  }}
                >
                  {cardData.map(card => (
                    <div
                      key={card.id}
                      style={{ userSelect: "none", cursor: "pointer" }}
                      className={`d-flex flex-column gap-1 px-3 py-1 rounded mb-2 shadow ${
                        selectedCard?.id === card.id
                          ? "bg-purple text-white"
                          : "bg-white"
                      }`}
                      onClick={() => setSelectedCard(card)}
                    >
                      <div className="fw-bold d-flex justify-content-between align-items-center gap-2">
                        <div className="d-flex align-items-center gap-2">
                          {/* 
                            <FaRegCalendarAlt
                              style={{
                                color: selectedCard?.id === card.id ? "#ffffff" : "#000000",
                                marginTop: "10px",
                              }}
                            />
                          */}
                          <span style={{ marginTop: "10px" }}>
                            {formatDate(card.date)}
                          </span>
                        </div>
                        {/* Display Total Time for this date */}
                        <div
                          style={{
                            backgroundColor:
                              selectedCard?.id === card.id
                                ? "#ffffff33"
                                : "#e0e0e0",
                            color:
                              selectedCard?.id === card.id ? "#ffffff" : "#333",
                            borderRadius: "12px",
                            padding: "2px 8px",
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            minWidth: "90px",
                            textAlign: "center",
                            marginTop: "10px",
                          }}
                        >
                          {dailyTimes[card.date] || "00:00:00"} hrs
                        </div>
                      </div>
                      <div className="d-flex justify-content-between mt-1">
                        {/* Placeholder for future badges */}
                      </div>
                    </div>
                  ))}
                </div>

                {/* RIGHT SIDE TABLE */}
                <div className="col-md-10">
                  <div className="card h-100">
                    <Row>
                      <Col className="col-12 hr-report">
                        {selectedCard && (
                          <TimesheetTable
                            toDate={selectedCard?.date}
                            activeUser={selectedStaff}
                            // onTotalTimeChange={(time) => handleTotalTimeChange(selectedCard?.date, time)}
                          />
                        )}
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            ) : (
              <div className="card p-4 h-100">
                <Row>
                  <Col className="col-12 hr-report">
                    <Row className="justify-content-center">
                      <div className="col-md-4 d-flex flex-column align-items-center justify-content-center">
                        <img src={viewImg} alt="Image" width={400} />
                        <p className="text-purple fw-bold text-center lh-base">
                          📊 All staff Timesheet data is now available <br />
                          use filters to efficiently search and analyze
                          company-wide records. 📂📈
                        </p>
                      </div>
                    </Row>
                  </Col>
                </Row>
              </div>
            )}
          </div>

          <Modal isOpen={modalOpen} toggle={() => toggleModal(null)} size="xl">
            <ModalHeader toggle={() => toggleModal(null)}>
              Details for {selectedCard?.date}
            </ModalHeader>
            <ModalBody>
              {selectedCard && (
                <TimesheetTable
                  toDate={selectedCard?.date}
                  activeUser={selectedStaff}
                  // onTotalTimeChange={(time) => handleTotalTimeChange(selectedCard?.date, time)}
                />
              )}
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AdvancedTimesheetReport
